// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__i3L2L","main":"Layout_main__IIi6I","container":"Layout_container__RCHTa"};